import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { Input, Alert, Collapse, Popconfirm } from 'antd';
import BtnSubmit from '../Buttons/BtnSubmit.js';
const { TextArea } = Input;
const { Panel } = Collapse;

class Reflection extends Component {
  constructor(props){
    super(props);
    this.state = {
      textArea: ''
    }
  }

  handleReflectionChange(e){
    this.setState({textArea: e.target.value});
  }

  submit() {
    if(this.state.textArea.length < 1)
      return

    const {textArea} = this.state;
    this.props.submitReflection(textArea);

    this.setState({ textArea: '' });
  }

  renderPoem(){
    return this.props.text.lines.map((words, key) => {
      if(words === "")
        return <li key={'break_' + key}>&nbsp;</li>

      return <li key={words}>{words}</li>
    });
  }

  render() {
    return (
      <div id="Reflection">
        <Alert
          id="prompt"
          className = "prompt"
          message={this.props.data.prompt}
          showIcon = {true}
          description = ' '
        />
        <TextArea
          id = "reflection-textarea"
          placeholder = "Type reflection here..."
          type = "textarea"
          onChange = {(e) => this.handleReflectionChange(e)}
          value = {this.state.textArea}
          rows = {4}
          autosize={{ minRows: 4, maxRows: 6 }}
        />
      <Popconfirm
        placement="top"
        title = "Save this reflection?"
        onConfirm={() => this.submit()} okText="Yes" cancelText="No">
        <BtnSubmit id="reflection-submit" />
      </Popconfirm>
     <Collapse defaultActiveKey={['1']}>
       <Panel header={<h3>Entry</h3>} key="1">
         <p>{this.props.reflection}</p>
       </Panel>
       <Panel header={<h3>Poem</h3>} key="2">
         <ul className = "poem">
           <li className="title"><h2>{this.props.text.title}</h2></li>
           {this.renderPoem()}
         </ul>
       </Panel>
     </Collapse>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    text: state.course.text,
    reflection: state.entries.reflection
  };
}

export default connect(mapStateToProps, actions)(Reflection);



// WEBPACK FOOTER //
// ./src/components/Reflection/Reflection.js